import { Col, DatePicker, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import { SocketContext } from '../../../App';
import dayjs from 'dayjs';
import antMessage from '../../../utils/extend/AntdNotification';
import getList from '../../universal/getList';

export default function MenuSalePeriodEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**日期类型数据 */
    const [dateTypeData, setDateTypeData] = useState<any>();

    /**日期类型状态 */
    const [dateTypeState, setDateTypeState] = useState<any>(false);

    const [isSkipHolidayState, setIsSkipHolidayState] = useState<any>(false);

    /** 后端数据wmService */
    let wmService: any = "";

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    if (res.data.dateType === 'sale') {
                        setIsSkipHolidayState(true);
                    }
                }
            })
        }

        const fetchData = async () => {
            if (data.type === 'EDIT') {
                setDateTypeState(true);
            }

            form.setFieldsValue({ targetId: data.sendPageData.targetId });
            form.setFieldsValue({ targetKey: data.sendPageData.targetKey });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });

            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'showList',
                apiVariable: "dateType",
            }).then(res => {
                if (res.success) {
                    setDateTypeData(res.data);
                    // newDateTypeData(res.data, setDateTypeData, data.sendPageData.targetKey);
                }
            })
        }
        fetchData();
    }, [])

    // const newDateTypeData = async (rows: any, setData: any, targetKey: any) => {
    //     let newSelectData: Array<any> = [];
    //     for (var j = 0; j < rows.length; j++) {
    //         newSelectData.push({
    //             value: rows[j].id,
    //             label: rows[j].name,
    //             disabled: targetKey === 'menu' && rows[j].id === 'discount' ? true : false
    //         })
    //     }
    //     setData(newSelectData);
    // }

    //控制switch
    const switchChange = (e: any) => {
        if (e === 'discount') {
            setIsSkipHolidayState(false);
        }
        else {
            setIsSkipHolidayState(true);
            form.setFieldValue('isSkipHoliday', false);
        }
    }

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const changeDate = (e: any, key: any) => {
        if (key === 'startTime' && form.getFieldsValue()['endTime'] !== undefined) {
            if (dayjs(form.getFieldsValue()['endTime']).format("YYYY-MM-DD") < dayjs(e).format("YYYY-MM-DD")) {
                antMessage('error', '时间设置有误', '结束时间小于开始时间,请重新选择.');
                form.resetFields(['startTime']);
            }
        }

        if (key === 'endTime') {
            if (dayjs(form.getFieldsValue()['startTime']).format("YYYY-MM-DD") > dayjs(e).format("YYYY-MM-DD")) {
                antMessage('error', '时间设置有误', '开始时间大于结束时间,请重新选择.');
                form.resetFields(['endTime']);
            }
        }
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuSaleDate',
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        },
        dateColumnName: ['startTime', 'endTime']
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '销售 / 折扣时间'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="branchStoreId"
                                name="branchStoreId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="targetId"
                                name="targetId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="targetKey"
                                name="targetKey">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="时间类型"
                                name="dateType"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择时间类型',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    disabled={dateTypeState}
                                    onChange={switchChange}
                                    placeholder="请选择时间类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(dateTypeData, {
                                        itemName: "name",
                                        includeNull: false
                                    })}
                                </Select>
                                {/* <Select
                                    disabled={dateTypeState}
                                    showSearch
                                    placeholder="请选择时间类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                    options={dateTypeData}
                                >
                                </Select> */}
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="开始时间"
                                name="startTime"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择时间',
                                    },
                                ]}
                            >
                                <DatePicker
                                    onChange={(e) => changeDate(e, 'startTime')}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="结束时间"
                                name="endTime"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择时间',
                                    },
                                ]}
                            >
                                <DatePicker
                                    onChange={(e) => changeDate(e, 'endTime')}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="跳过节假日"
                                name="isSkipHoliday"
                                valuePropName="checked"
                                tooltip="如选择【是】则根据设定的节假日进行跳过"
                            >
                                <Switch
                                    disabled={isSkipHolidayState}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}